
import { VAutocomplete } from 'vuetify/lib';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({ name: 'd4y-autocomplete' })
export default class D4yAutocomplete extends VAutocomplete {
  @Prop({ default: false })
  rounded!: boolean;
  @Prop({ default: true })
  outlined!: boolean;
  @Prop({ default: true })
  dense!: boolean;

  @Prop({ default: 'mdi-chevron-down' })
  appendIcon!: string;
}
